import { createSelector } from 'reselect';

export const selectPhotoMetaCollection = createSelector(({ photo }) => photo.photoMetaCollection, result => result);

export const selectPhotosToUpload = createSelector(
  selectPhotoMetaCollection,
  photos => {
    if (!photos) return null;
    return photos.filter(p => !p.IsDeleted && !p.externalURL && !p.IsError);
  },
);

export const selectPhotosToDisplay = createSelector(selectPhotoMetaCollection,
  photos => {
    if (!photos) return null;
    return photos.filter(pm => !pm.IsDeleted && pm.externalURL);
  });

export const selectValidPhotos = createSelector(selectPhotoMetaCollection, photoMetas => photoMetas.filter(pM => !pM.IsDeleted));

export const selectPhotoToEdit = createSelector(({ photo }) => photo.editPhotoMeta, result => result);

export const selectMaxSortOrder = createSelector(selectPhotoMetaCollection, allPhotos => {
  if (!allPhotos) return 0;
  if (allPhotos.length === 0) return 0;
  return allPhotos.filter(photoMeta => !photoMeta.IsDeleted).length;
});

export const selectPhotoQueueLength = createSelector(selectPhotoMetaCollection, allPhotos => {
  if (!allPhotos) return 0;
  if (allPhotos.length === 0) return 0;
  return allPhotos.filter(photo => !photo.IsUploaded && !photo.IsError).length;
});

export const selectDisplayedPhotoCount = createSelector(selectPhotosToDisplay, displayPhotos => displayPhotos.length);
